// İSG uzmanı portalı — Eğitim & Test (Training) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("training", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useTrainingAccess) sonucuna göre Eğitim alt-ağacını (Outlet: liste +
// editör), 403 sayfasını veya "kullanılamıyor" durumunu gösterir. Taşeron/İş İzni kapılarıyla
// aynı desen; iş modülü olarak AYRIDIR (modül Value = `training`).

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { GraduationCap, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useTrainingAccess } from '../../lib/trainingAccess';

export function TrainingsGate() {
  const { t } = useTranslation();
  const access = useTrainingAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('trainings.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <GraduationCap className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('trainings.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('trainings.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('trainings.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('trainings.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('trainings.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('trainings.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
